import { GetQRCodePDFDTO } from 'dto/qr';
import { post } from './common';

export const generateQRCodePDF = async (options: GetQRCodePDFDTO[]): Promise<BlobPart> => {
  return post('/qr', options, { responseType: 'blob' }).then(response => response.data);
};
